"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PolicyWithNavigate = function (_a) {
    var title = _a.title, htmlContent = _a.htmlContent;
    var t = (0, next_intl_1.useTranslations)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.contentBox },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t("policyPages.".concat(title))),
                (0, react_html_parser_1.default)(htmlContent)),
            react_1.default.createElement(ui_components_1.ScrollToTop, null))));
};
exports.default = PolicyWithNavigate;
